/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { useState } from 'react';
import Logotype from '../../assets/images/Logotype-Original.svg'
import Userlogo from '../../assets/images/male.png'
import './top-header.scss'


const TopHeader = () => {
    let user: any = {};
    try {
      user = JSON.parse(localStorage.getItem("user") ?? "{}");
    } catch {
      user = {};
    }
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleLogout = () => {
        // Step 1: Clear all session tokens and user data
        localStorage.clear();  // Clears everything in localStorage
        sessionStorage.clear(); // Clears everything in sessionStorage
        // Optionally, remove cookies if you're using them for tokens
        document.cookie.split(";").forEach((c) => {
            document.cookie = c.trim().split("=")[0] + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
        });

        // Step 2: Redirect to login page
        toast.success('Logged out successfully!', {
            position: "top-right",
            autoClose: 2000,
            theme: "colored",
            });
        navigate('/');
    };

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light fixed-top clsNavbar tv-topnav--v2">
                <div className="clsLogo">
                    <a href="#" className="navbar-brand">
                    <img src={Logotype} alt=""/>
                    <span> Manufacturing Partner Portal </span>
                    </a>
                </div>
                <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                    <div className="tv-company-chip clsMobileHide">
                        <span className="tv-company-title">Precision Parts Inc.</span>
                        <span className="tv-company-sub">Manufacturing Partner</span>
                    </div>
                    <ul className="navbar-nav clsMobileHide">
                    {/* <li className="nav-item">
                        <a className="nav-link" href="#" data-toggle="tooltip" data-placement="bottom"
                        title="Notification">
                        <i className="fa fa-bell"></i>
                        </a>
                    </li>

                    <li className="nav-item">
                        <a className="nav-link" href="#" data-toggle="tooltip" data-placement="bottom" title="Email">
                        <i className="fa fa-envelope"></i>
                        </a>
                    </li> */}

                    <li className="nav-item dropdown">
                        <a className="nav-link tv-user-chip" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false" onClick={toggleDropdown}>
                        <span className="tv-user-name">{user?.name ?? "User"}</span>
                        <img src={Userlogo} alt="" className="clsWidth-30"/>
                        </a>
                        <div className={`dropdown-menu dropdown-menu-right ${isDropdownOpen ? 'show' : ''}`} id="headerProfileDropdown" aria-labelledby="navbarDropdown">
                        <span className="p-l-5"> {user?.name ?? "Username"} </span>
                        <a className="dropdown-item" href="#" onClick={handleLogout}> Logout </a>
                        </div>
                    </li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}
export default TopHeader
